import { Card } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { PageWrapper } from "../../../shared/layout";
import { commonStyle } from "./commonStyles";
import CommonCardContent from "./CommonCardContent";
import "./settlementGrid.css";

const styles = commonStyle;

class DueGeneratedDetailsCard extends PureComponent {
  // TODO: Remove unnecessary code
  render() {
    const {
      classes, data, gridStrings, isLoading,
    } = this.props;

    return (
      <div>
        <PageWrapper.Header
          heading={`Dues Created On ${moment(data.dueGeneratedDate).format(
            "DD MMM YYYY",
          )}`}
          hideS
          isHeaderFixed={false}
          removeFilterOnly
          hideDivider
          hideLower
        />
        <PageWrapper.Body style={{ marginTop: 0 }}>
          <Card className={[classes.cardWrapper, "settlement-scroll"]}>
            <div className={classes.details}>
              {Object.keys(gridStrings).map((key) => (
                <CommonCardContent
                  key={key}
                  cardKey={key}
                  classes={classes}
                  data={data}
                  gridStrings={gridStrings}
                  isLoading={isLoading}
                />
              ))}
            </div>
          </Card>
        </PageWrapper.Body>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(DueGeneratedDetailsCard));
